<template>
  <router-view :key="subscriptionTemplateId"></router-view>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ProductContainer',

  props: {
    subscriptionTemplateId: {
      type: String,
      required: false,
      default: 'catalogue',
    },
  },

  beforeDestroy() {
    this.resetCatalogue();
  },

  methods: {
    ...mapActions('catalogue', {
      resetCatalogue: 'reset',
    }),
  },
};
</script>
